var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',_vm._b({attrs:{"size":"small","start-placeholder":"开始日期","end-placeholder":"结束日期","value":_vm.value,"editable":false},on:{"input":_vm.input}},'el-date-picker',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }